<template>
  <div
    style="background: linear-gradient(to bottom,#5ce5fb 0,#2fc6f6 100%);display: flex; flex: 1; width: 100%; min-height: 100%;">
    <div class="b24-network-auth-cover">
      <div class="b24-network-auth-cover-top">
        <div class="b24-network-auth-cover-img-block">
          <span class="h1 text-white ms-2 gordo">ue-tulcan<span style="color: #0065a3 !important;">.com <i
                class="bi bi-star"></i></span></span>
        </div>
        <div class="b24-network-auth-cover-back" style="z-index: 999;">
          <a href="ue-tulcan.com" class="text-white"><i class="bi bi-arrow-left"></i> volver al sitio web</a>
        </div>
      </div>
      <div class="b24-network-auth-cover-header">
        <div class="b24-network-auth-cover-header">
          <div class="text-white h1">Unidad. Educativa</div>
          <div class="b24-network-auth-cover-subtitle">
            <span class="h5 text-white delgado">Tulcán</span>
          </div>
          <br>
          <div class="b24-network-auth-cover-subtitle">
            <span style="font-size: 26px; color: #07596D;">
              Sistema interno para el registro de notas, aulas virtuales, horarios, planificaciones y mas..</span>
          </div>
        </div>
      </div>
      <div class="b24-network-auth-cloud-block">
        <div class="b24-network-auth-cloud b24-network-auth-cloud-lg"></div>
        <div class="b24-network-auth-cloud b24-network-auth-cloud-sm"></div>
        <div class="b24-network-auth-cloud b24-network-auth-cloud-md"></div>
        <div class="b24-network-auth-cloud b24-network-auth-cloud-fill"></div>
      </div>
      <div class="mt-5 text-end">
        <button class="btn btn-base3 btn-fondo">CONTACTANOS</button>
      </div>
    </div>
    <div class="b24-network-auth-form ">
      <div class="b24-network-auth-form-wrap">
        <div class=" mb-3" v-if="isVisible == 'logins'">
          <div class="pb-2">
            <p class="h2 s-color-puro delgado" style="color: #333;">Ingreso al sistema interno</p>
          </div>
          <hr class="s-hr-color" style="margin: .8rem 0;">
          <div class="text-center">
            <p style="color: #777d86;">Utilice sus cuentas en redes sociales para ingresar</p>
            <button @click="logins" class="btn btn-base3 btn-opaco me-3">
              <svg style="color: #1877f2;" fill="none" height="24" viewBox="0 0 24 24" width="24"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21.5 12.058c0-5.28-4.253-9.558-9.5-9.558s-9.5 4.279-9.5 9.558c0 4.771 3.473 8.725 8.016 9.442v-6.68H8.104v-2.762h2.412V9.952c0-2.395 1.417-3.718 3.588-3.718 1.04 0 2.126.186 2.126.186v2.352h-1.198c-1.18 0-1.548.738-1.548 1.494v1.792h2.635l-.421 2.763h-2.214V21.5c4.543-.717 8.016-4.67 8.016-9.442z"
                  fill="currentColor"></path>
              </svg>
            </button>
            <button @click="logins" class="btn btn-base3 btn-opaco me-3">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="24" width="24">
                <path fill="#4285f4" d="M386 400c45-42 65-112 53-179H260v74h102c-4 24-18 44-38 57z"></path>
                <path fill="#34a853" d="M90 341a192 192 0 0 0 296 59l-62-48c-53 35-141 22-171-60z"></path>
                <path fill="#fbbc02" d="M153 292c-8-25-8-48 0-73l-63-49c-23 46-30 111 0 171z"></path>
                <path fill="#ea4335" d="M153 219c22-69 116-109 179-50l55-54c-78-75-230-72-297 55z"></path>
              </svg>
            </button>
            <button @click="logins" class="btn btn-base3 btn-opaco me-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
                <path d="M11 3H3v8h8V3z" fill="#f25022"></path>
                <path d="M21 3h-8v8h8V3z" fill="#7fba00"></path>
                <path d="M11 13H3v8h8v-8z" fill="#00a4ef"></path>
                <path d="M21 13h-8v8h8v-8z" fill="#ffb900"></path>
              </svg>
            </button>
            <button @click="logins" class="btn btn-base3 btn-opaco me-3">
              <img src="../../../assets/img/new/github.svg" style="height: 27px;" alt="">
            </button>
            <button @click="logins" class="btn btn-base3 btn-opaco">
              <img src="../../../assets/img/new/apple.svg" alt="">
            </button>
          </div>
          <hr class="s-hr-color" style="margin: .8rem 0;">
          <p style="color: #777d86;">O Utilice su usuario y contraseña para ingresar</p>
          <form @submit.prevent="authenticate">
            <label for="yourUsername" class="s-color-tres s-labes-with text-sm mb-2 ">Cédula o
              dirección de correo</label>
            <input v-model="login.email" placeholder="Cedula" type="text" style="height: 49px !important;"
              class="form-control form-base2 seachh-platzi" required autocomplete="off" />
            <div class="mb-3"> <label for="yourPassword" class="s-color-tres s-labes-with text-sm mt-2 mb-2">Contraseña
                <span style="font-size: 17px;cursor: pointer;" class="ms-2">
                  <svg class="s-color-puro" @click="toggleShow" v-if="showPassword" data-testid="geist-icon" fill="none"
                    height="18" shape-rendering="geometricPrecision" stroke="currentColor" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" width="18">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                  <svg class="s-color-puro" @click="toggleShow" v-else data-testid="geist-icon" fill="none" height="18"
                    shape-rendering="geometricPrecision" stroke="currentColor" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" width="18">
                    <path
                      d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24">
                    </path>
                    <path d="M1 1l22 22"></path>
                  </svg>
                </span>
              </label> <input v-if="showPassword" type="text" class="form-control form-base2 seachh-platzi"
                style="height: 49px !important;" v-model="login.password" />
              <input v-else v-model="login.password" type="password" style="height: 49px !important;"
                class="form-control form-base2 seachh-platzi" required />
            </div>

            <div class="text-center mb-3">
              <button class="btn btn-base3 btn-verde mt-2 mb-0"
                style="font-size: 16px !important; border-radius: 30px !important; height: 52px !important; padding: 0px 70px !important;">
                <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{ isLoading ? 'Cargando...' : 'INICIAR SESIÓN' }} <i class="bi bi-arrow-right"></i>
              </button>
            </div>
            <a @click="isVisible = 'passw'" href="javascript:;" class="links2 gordo3">
              Olvidaste tu contraseña?
            </a>
          </form>
        </div>
        <!--  REXUPERAR CONTRASEÑA  -->
        <div v-if="isVisible == 'passw'" class="card mb-3" style="background: transparent;border: 0px;box-shadow: none;">
          <ResetPass @emitGoBackLogin="goBackLogin" @emitCambioPageResset="goRessetPassword"
            @emitGoUserError="goUserError" />
        </div>
        <!--  VEFIFICAR CODE  -->
        <div v-if="isVisible == 'forgot'" class="card mb-3" style="background: transparent;border: 0px;box-shadow: none;">
          <CheckCode :codex="code" @emitGoPageUpdatePassword="goUpdatePassword" @emitGoBackLogin2="goBackLogin" />
        </div>
        <!--  RESET PASS  -->
        <div v-if="isVisible == 'resett'" class="card mb-3" style="background: transparent;border: 0px;box-shadow: none;">
          <Update :email="emailss" @emitGoBackLogin3="goBackLogin" />
        </div>
      </div>

    </div>
  </div>
</template> 
<style>
.b24-network-auth-cloud-block {
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
}

.b24-network-auth-cloud {
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  pointer-events: none;
}

.b24-network-auth-cloud-lg {
  top: 116px;
  left: -180px;
  width: 760px;
  height: 474px;
  transition: left 5s ease-in-out;
  background-image: url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%22754%22%20height%3D%22474%22%20viewBox%3D%220%200%20754%20474%22%20fill%3D%22none%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%0A%20%20%3Cpath%20opacity%3D%22.399%22%20d%3D%22M617.36%20131.239C610.323%2058.159%20548.315%201%20472.835%201c-58.294%200-108.54%2034.11-131.651%2083.3-15.49-5.59-32.204-8.646-49.641-8.646-80.2%200-145.213%2064.521-145.213%20144.117%200%203.765.19%207.484.475%2011.177a124.73%20124.73%200%200%200-30.016-3.659C48.421%20227.289-7%20282.292-7%20350.145-7%20417.996%2048.42%20473%20116.789%20473h461.853C674.938%20473%20753%20395.521%20753%20299.952c0-82.358-57.985-151.228-135.64-168.713%22%20stroke%3D%22white%22/%3E%0A%3C/svg%3E%0A);
}

.b24-network-auth-cloud-sm {
  top: 143px;
  right: 1%;
  width: 66px;
  height: 42px;
  transition: right 5s ease-in-out;
  background-image: url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20viewBox%3D%220%200%2068%2042%22%20fill%3D%22none%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%0A%20%20%3Cpath%20opacity%3D%22.399%22%20vector-effect%3D%22non-scaling-stroke%22%20d%3D%22M54.944%2012.11C54.336%205.875%2048.98%201%2042.457%201c-5.036%200-9.377%202.91-11.374%207.106a12.756%2012.756%200%200%200-4.29-.738c-6.928%200-12.545%205.504-12.545%2012.293%200%20.321.016.638.04.953a10.909%2010.909%200%200%200-2.593-.312C5.788%2020.302%201%2024.994%201%2030.782s4.788%2010.48%2010.695%2010.48H51.6c8.32%200%2015.064-6.61%2015.064-14.762%200-7.025-5.01-12.9-11.719-14.39%22%20stroke%3D%22white%22/%3E%0A%3C/svg%3E%0A);
}

.b24-network-auth-cloud-md {
  top: 73%;
  right: -12%;
  width: 188px;
  height: 119px;
  transition: right 5s ease-in-out;
  background-image: url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%22190%22%20height%3D%22119%22%20viewBox%3D%220%200%20190%20119%22%20fill%3D%22none%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%0A%20%20%3Cpath%20opacity%3D%22.399%22%20d%3D%22M155.17%2033.356C153.433%2015.2%20138.121%201%20119.483%201c-14.394%200-26.8%208.474-32.508%2020.695a35.846%2035.846%200%200%200-12.257-2.148c-19.804%200-35.857%2016.029-35.857%2035.803%200%20.936.047%201.86.117%202.777a30.624%2030.624%200%200%200-7.411-.909C14.685%2057.218%201%2070.883%201%2087.74s13.685%2030.521%2030.567%2030.521H145.61c23.778%200%2043.053-19.248%2043.053-42.99%200-20.462-14.318-37.571-33.493-41.915%22%20stroke%3D%22white%22/%3E%0A%3C/svg%3E%0A);
}

.b24-network-auth-cloud-fill {
  top: 83%;
  left: 124px;
  width: 127px;
  height: 80px;
  background-image: url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20viewBox%3D%220%200%20127%2080%22%20fill%3D%22none%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%0A%20%20%3Cpath%20opacity%3D%22.2%22%20fill-rule%3D%22evenodd%22%20vector-effect%3D%22non-scaling-stroke%22%20stroke-width%3D%221%22%20%20clip-rule%3D%22evenodd%22%20d%3D%22M104.057%2021.87C102.884%209.598%2092.55%200%2079.97%200c-9.715%200-18.09%205.728-21.94%2013.988a24.161%2024.161%200%200%200-8.274-1.452c-13.366%200-24.202%2010.835-24.202%2024.201%200%20.633.032%201.257.08%201.877A20.636%2020.636%200%200%200%2020.63%2038C9.237%2038%200%2047.236%200%2058.63c0%2011.395%209.237%2020.631%2020.631%2020.631h76.973c16.049%200%2029.059-13.01%2029.059-29.059%200-13.83-9.664-25.395-22.606-28.331z%22%20fill%3D%22white%22/%3E%0A%3C/svg%3E%0A);
  transition: left 5s ease-in-out;
}

.b24-network-auth-cover {
  color: #fff;
  padding: 59px 49px 49px 66px;
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1;
  flex-grow: 4;
  -webkit-box-flex: 4;
  -ms-flex-positive: 4;
  box-sizing: border-box;
  min-width: 450px;
  max-width: 900px;
  transition: transform .7s cubic-bezier(.36, .15, .26, .99), opacity .7s cubic-bezier(.36, .15, .26, .99);
  min-height: 100vh;
}

@media (max-width: 1080px) {
  .b24-network-auth-form {
    padding-top: 45px;
  }

  .b24-network-auth-cover {
    min-width: 250px;
    flex-grow: 1;
    max-width: 310px;
    padding: 45px 49px 49px 42px;
  }
}

@media (max-width: 760px) {
  .b24-network-auth-cover {
    display: none;
  }
}

.b24-network-auth-cover-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 183px;
  flex-wrap: wrap !important;
}

.b24-network-auth-cover-header {
  max-width: 493px;
}

.b24-network-auth-form-wrap {
  max-width: 580px;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.b24-network-auth-form {
  display: flex;
  justify-content: center;
  overflow: auto;
  box-sizing: border-box;
  padding: 95px 60px 10px;
  min-height: 100vh;
  background: #fff;
  box-shadow: -2px 0 22px rgba(0, 0, 0, .12);
  transition: transform .8s cubic-bezier(.36, .15, .26, .99), opacity .8s cubic-bezier(.36, .15, .26, .99);
  flex: 1;
  flex-grow: 6;
  -webkit-box-flex: 6;
  -ms-flex-positive: 6;
}
</style>
<script>
import { defineAsyncComponent } from 'vue'
export default {
  data() {
    return {
      tab: "login",
      login: {
        email: null,
        password: null,
        ip: null,
        navegador: 'none',
      },
      infos: {},
      isLoading: false,
      isVisible: "logins",
      model: {
        email: null,
        ip: null,
        navegador: 'none',
      },
      showPassword: false,
      user: this.$eartho.user,
      isAuthGoogle: false,
      code: "",
      emailss: '',
      term: "127.0.0.1",
      navegador: "",
    };
  },
  components: {
    CheckCode: defineAsyncComponent(() =>
      import('../components/CheckCode.vue')
    ),
    ResetPass: defineAsyncComponent(() =>
      import('../components/ResetPass.vue')
    ),
    Update: defineAsyncComponent(() =>
      import('../components/Update.vue')
    ),
  },
  computed: {
    buttonLabel() {
      return (this.showPassword) ? "Hide" : "Show";
    }
  },
  created() {
    this.navegador = getOS()
    localStorage.setItem("nav", this.navegador);
  },
  methods: {
    goBackLogin: function () {
      this.isVisible = "logins";
    },
    goRessetPassword: function (codex, emin) {
      this.isVisible = "forgot";
      this.code = codex;
      this.emailss = emin;
    },
    goUpdatePassword: function () {
      this.isVisible = "resett";
    },
    goUserError: function () {
      this.isVisible = "error";
    },
    async logins() {
      try {
        this.isLoading = true;
        await this.$eartho.connectWithPopup({ access_id: "LQL6qdq68vaZek6KQ4ec" })
        const rawObject = JSON.parse(JSON.stringify(this.user));
        const foundUser = rawObject.user
        this.postGoogleAuth(foundUser)
      } catch (error) {
        this.isLoading = false;
        console.log(error)
      }
    },
    postGoogleAuth(users) {
      this.isLoading = true;
      this.model.email = users.email;
      this.model.ip = 'secure'
      this.model.navegador = this.navegador
      this.$proxies.identityProxy
        .GoogleAuthApi(this.model)
        .then((x) => {
          const { foto, tokens, thema } = x.data.isaccesos
          localStorage.setItem("access_token", tokens);
          let imagens = users.photoURL ? users.photoURL : foto
          localStorage.setItem("Avatar", JSON.stringify(imagens));
          localStorage.setItem("adress", this.model.ip);
          if(thema) {
            localStorage.setItem("theme", thema);
          }
          this.goToPage();
          this.isLoading = false;
        })
        .catch((x) => {
          if (!x.response) {
            this.$toast.error(`Por favor revise su conexion a internet`);
          }
          if (x.response.status == 400) {
            this.$toast.error(`La cuenta con la intenta ingresar tiene que estar registrado en su cuenta/perfil`);
          } else {
            this.$toast.error(`ERROR`);
          }
          this.isLoading = false;
        });
    },
    authenticate() {
      this.isLoading = true;
      this.login.email = this.login.email.trim()
      this.login.password = this.login.password.trim()
      this.login.ip = this.term
      this.login.navegador = this.navegador
      this.$proxies.identityProxy
        .login(this.login)
        .then(x => {
          const { foto, tokens, ip, thema } = x.data.isaccesos
          localStorage.setItem("access_token", tokens);
          localStorage.setItem("Avatar", JSON.stringify(foto));
          localStorage.setItem("adress", ip);
          if(thema) {
            localStorage.setItem("theme", thema);
          }
          this.goToPage();
        })
        .catch(x => {
          if (!x.response) {
            this.$toast.error(`Por favor revise su conexion a internet`);
          } else if (x.response.status == 400) {
            this.$toast.error(`El usuario no esta registrado en el sistema`);
          } else if (x.response.status == 402) {
            this.$toast.error(`Su contraseña es Invalida`);
          } else {
            this.$toast.error(`ERROR`);
          }
          this.isLoading = false;
        });
    },
    goToPage: function () {
      this.isLoading = false;
      this.$parent.isLoggedIn = true;
      this.$store.commit('signIn');
      this.$toast.show(`Su acceso ha sido validado correctamente`, {
        position: "bottom-right",
      });
      this.$router.push("/").catch(() => { });
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    }
  }

};
function getOS() {
  var BROWSER = new Array(
    ["Microsoft Edge", /edg/i],
    ["Microsoft Internet Explorer", /trident/i],
    ["Mozilla Firefox", /firefox|fxios/i],
    ["Opera", /opr\//i],
    ["UC Browser", /ucbrowser/i],
    ["Samsung Browser", /samsungbrowser/i],
    ["Google Chrome", /chrome|chromium|crios/i],
    ["Apple Safari", /safari/i],
    ["Unknown", /.+/i],
  ).find(([, value]) => value.test(window.navigator.userAgent)).shift();
  return BROWSER
}
</script>
  